<template>
	<div class="console">
		<template v-if="$route.name=='console'">
			<div v-if="tips.length>0" class="grid-content tips">
				<template v-for="(t,index) in tips">
					<div class="box" :style="'background-color:'+t.bg_color+';border-left: .3125rem solid '+t.color">
						<i class="el-icon-warning" :style="{color:t.color}"></i>
						<span style="font-size: 0.875rem;" :style="{color:t.color}">{{t.text}}</span>
					</div>
				</template>
			</div>
			<el-row :gutter="20">
				<el-col :span="16">
					<div class="grid-content total" v-loading="loading">
						<div class="box">
							<el-row :gutter="20">
								<el-col style="width: 25%;">
									<div class="content abg">
										<i class="el-icon-s-finance"></i>
										<div class="h">
											<div class="l">今日</div>
											<div class="r">营业额</div>
										</div>
										<div class="num">
											<div class="n">{{total.a}}元</div>
										</div>
									</div>
								</el-col>
								<el-col style="width: 25%;">
									<div class="content dbg">
										<i class="el-icon-s-order"></i>
										<div class="h">
											<div class="l">今日</div>
											<div class="r">新增订单</div>
										</div>
										<div class="num">
											<div class="n">{{total.c}}笔</div>
										</div>
									</div>
								</el-col>
								<el-col style="width: 25%;">
									<div class="content cbg">
										<i class="el-icon-s-custom"></i>
										<div class="h">
											<div class="l">今日</div>
											<div class="r">新增用户</div>
										</div>
										<div class="num">
											<div class="n">{{total.e}}人</div>
										</div>
									</div>
								</el-col>
								<el-col style="width: 25%;">
									<div class="content ebg">
										<i class="el-icon-s-comment"></i>
										<div class="h">
											<div class="l">今日</div>
											<div class="r">新增评价</div>
										</div>
										<div class="num">
											<div class="n">{{total.g}}条</div>
										</div>
									</div>
								</el-col>
							</el-row>
							<el-row :gutter="20" style="margin-top: 0.625rem;">
								<el-col style="width: 25%;">
									<div class="content zr" @click="onClickMode('order')">
										<div class="z">昨日</div>
										<span class="a">{{total.b}}</span>
										<span class="b">元</span>
										<i class="el-icon-arrow-right"></i>
									</div>
								</el-col>
								<el-col style="width: 25%;">
									<router-link :to="{name:'order_list_all'}" style="color: #2c3e50;">
										<div class="content zr">
											<div class="z">昨日</div>
											<span class="a">{{total.d}}</span>
											<span class="b">笔</span>
											<i class="el-icon-arrow-right"></i>
										</div>
									</router-link>
								</el-col>
								<el-col style="width: 25%;">
									<router-link :to="{name:'user'}" style="color: #2c3e50;">
										<div class="content zr">
											<div class="z">昨日</div>
											<span class="a">{{total.f}}</span>
											<span class="b">人</span>
											<i class="el-icon-arrow-right"></i>
										</div>
									</router-link>
								</el-col>
								<el-col style="width: 25%;">
									<router-link :to="{name:'order_comment'}" style="color: #2c3e50;">
										<div class="content zr">
											<div class="z">昨日</div>
											<span class="a">{{total.h}}</span>
											<span class="b">条</span>
											<i class="el-icon-arrow-right"></i>
										</div>
									</router-link>
								</el-col>
							</el-row>
						</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="grid-content cost">
						<div class="title">
							<div class="l"
								style="width: 50%;position: relative;padding-left: 1.5rem;color: black;font-weight: bold;font-size: 1rem;box-sizing: border-box;">
								<i class="el-icon-files" style="position: absolute;left: 0;font-size: 1.2rem;"></i>
								<span>费用中心</span>
							</div>
							<div class="r more" style="width: 50%;">
								<router-link :to="{name:'console_cost'}">
									<span class="link more">
										<span>详情</span>
										<i class="el-icon-arrow-right"></i>
									</span>
								</router-link>
							</div>
						</div>
						<div class="con" v-loading="loading">
							<div class="box">
								<div class="item">
									<div class="l">系统余额</div>
									<div class="r">
										<span>{{cost.amount}}元</span>
										<el-tooltip v-if="cost.amount" effect="dark" content="司机线上支付的金额将计入此余额，最低留存500元"
											placement="top">
											<i class="el-icon-question"></i>
										</el-tooltip>
										<el-button class="btn" type="primary" size="mini" @click="onAmount">充提
										</el-button>
									</div>
								</div>
								<div class="item">
									<div class="l">维护费</div>
									<div class="r">
										<span>{{cost.maintain}}</span>
										<el-tooltip v-if="cost.maintain" effect="dark" content="维护费会从系统余额扣除，余额不足将导致下单异常"
											placement="top">
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
								</div>
								<div class="item">
									<div class="l">信誉分</div>
									<div class="r">
										<el-rate :value="cost.prestige" :max="5" disabled show-score text-color="#ff9900">
										</el-rate>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-row :gutter="20" style="margin-top: 1.25rem;">
						<el-col :span="12">
							<div class="grid-content echarts">
								<div style="width: 100%;height: 18.5rem;" ref="tj1" v-loading="loading">
								</div>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="grid-content echarts">
								<div style="width: 100%;height: 18.5rem;" ref="tj2" v-loading="loading">
								</div>
							</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-row :gutter="20" style="margin-top: 1.25rem;">
						<el-col :span="17">
							<el-card class="box-card-help" shadow="never" style="border-radius: 0;">
								<div slot="header" class="clearfix">
									<span>操作日志</span>
									<span class="link more" @click="onAdminlog">
										<span>更多</span>
										<i class="el-icon-arrow-right"></i>
									</span>
								</div>
								<el-skeleton v-if="loading" :loading="loading" animated :count="6">
									<template slot="template">
										<div class="item">
											<div class="text">
												<el-skeleton-item variant="text" style="width: 50%;" />
											</div>
											<div class="time">
												<el-skeleton-item variant="text" style="width: 5rem;" />
											</div>
										</div>
									</template>
								</el-skeleton>
								<template v-else>
									<div v-for="(log,index) in adminlog" class="item">
										<div class="text">{{log.text}}</div>
										<div class="time">{{log.time}}</div>
									</div>
								</template>
							</el-card>
						</el-col>
						<el-col :span="7">
							<el-card class="box-card-help copys" shadow="never" style="border-radius: 0;">
								<div slot="header" class="clearfix">
									<span>系统信息</span>
									<span
										style="float: right; font-size: 12px; font-weight: 400;color: red;">禁止截屏</span>
								</div>
								<el-form label-position="left" inline class="box">
									<el-form-item label="系统状态">
										<span style="color: #07c160;" class="el-icon-success"></span>
										<span style="color: #07c160;">正常</span>
									</el-form-item>
									<el-form-item label="安全运行">
										<span>{{day}}</span>
									</el-form-item>
									<el-form-item label="系统版本">
										<span>Workerman V2.13.2</span>
									</el-form-item>
									<el-form-item label="系统运营">
										<span>漳浦肆伍陆代驾服务有限公司</span>
									</el-form-item>
									<el-form-item label="技术支持">
										<span>漳浦佳智网络科技有限公司</span>
									</el-form-item>
								</el-form>
								<div class="lx_code"><img src="../../assets/lx_code.png" /></div>
							</el-card>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-dialog title="操作日志" :visible.sync="dialog_adminlog.show" width="50%">
				<div class="table" v-loading="(dialog_adminlog.loading && dialog_adminlog.total>0)?true:false">
					<el-table :data="dialog_adminlog.list" border style="width: 100%" size="small">
						<el-table-column type="selection" align="center" width="55"></el-table-column>
						<el-table-column label="说明">
							<template slot-scope="scope">
								{{ scope.row.text }}
							</template>
						</el-table-column>
						<el-table-column align="center" width="165" label="时间">
							<template slot-scope="scope">
								{{ scope.row.time }}
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-if="dialog_adminlog.loading && dialog_adminlog.total<=0" style="min-height: 20rem;"
					v-loading="dialog_adminlog.loading"></div>
				<div v-if="dialog_adminlog.total>0" class="page" style="margin-top: 1.25rem; margin-bottom: 0px;">
					<el-pagination layout="total, prev, pager, next" :total="dialog_adminlog.total"
						@current-change="pageAdminLog">
					</el-pagination>
				</div>
			</el-dialog>
			<el-dialog title="充提二维码" :visible.sync="dialog_amount.show" width="30%" :center="true">
				<div class="amount-qrcode" v-loading="dialog_amount.loading">
					<img :src="dialog_amount.codeurl" />
				</div>
				<div class="amount-tips">请运营商使用司机端扫码操作</div>
			</el-dialog>
		</template>
		<router-view v-else ref="consoleCallback"></router-view>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data() {
			return {
				loading: true,
				day: "0天",
				tips: [],
				total: {
					a: "0.00",
					b: "0.00",
					c: 0,
					d: 0,
					e: 0,
					f: 0,
					g: 0,
					h: 0
				},
				cost: {
					amount: "0.00",
					maintain: "-",
					prestige: 0
				},
				chart1: null,
				chart2: null,
				echarts: {},
				adminlog: [],
				dialog_adminlog: {
					show: false,
					loading: true,
					page: 1,
					list: [],
					total: 0
				},
				dialog_amount: {
					show: false,
					loading: true,
					codeurl: null
				}
			};
		},
		mounted() {
			this.initSystemDay();
			this.postConsole();
			this.$emit("console_events", {
				mode: 'header'
			});
		},
		methods: {
			initSystemDay() {
				let X = new Date("1/11/2019 16:09:18");
				let Y = new Date();
				let T = (Y.getTime() - X.getTime());
				let M = 24 * 60 * 60 * 1000;
				let a = T / M;
				let A = Math.floor(a);
				let b = (a - A) * 24;
				let B = Math.floor(b);
				this.day = A + "天" + B + "小时";
			},
			onEcharts() {
				const that = this;
				if (that.$route.name != "console") return;
				that.$nextTick(() => {
					that.chart1 = echarts.init(that.$refs.tj1);
					that.chart2 = echarts.init(that.$refs.tj2);
					that.chart1.setOption({
						color: ["#3fb1e4"],
						title: {
							text: '近一周营业额',
							textStyle: {
								fontSize: 17,
								color: "#000"
							}
						},
						tooltip: {},
						legend: {
							x: 'right',
							data: ['营业额']
						},
						xAxis: {
							data: that.echarts.date
						},
						yAxis: {},
						series: [{
							name: '营业额',
							type: 'line',
							data: that.echarts.amount
						}]
					});
					that.chart2.setOption({
						title: {
							text: '近一周产量',
							textStyle: {
								fontSize: 17,
								color: "#000"
							}
						},
						tooltip: {
							trigger: 'axis'
						},
						legend: {
							x: 'right',
							data: ['订单量', '新增用户', '新增评价']
						},
						xAxis: {
							data: that.echarts.date
						},
						yAxis: {},
						series: [{
								name: '订单量',
								type: 'bar',
								data: that.echarts.order
							},
							{
								name: '新增用户',
								type: 'bar',
								data: that.echarts.user
							},
							{
								name: '新增评价',
								type: 'bar',
								data: that.echarts.comment
							}
						]
					}, true);
					window.addEventListener('resize', function() {
						that.chart1.resize();
						that.chart2.resize();
					});
				});
			},
			onAmount() {
				const that = this;
				that.dialog_amount.loading = true;
				that.dialog_amount.show = true;
				that.$post('consoleAmount').then(res => {
					setTimeout(function() {
						that.dialog_amount.loading = false;
						that.dialog_amount.codeurl = res.data.codeurl;
					}, 500);
				}).catch(e => {
					that.dialog_amount.show = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			pageAdminLog(page) {
				const that = this;
				that.dialog_adminlog.loading = true;
				that.dialog_adminlog.page = page;
				that.onAdminlog();
			},
			onAdminlog() {
				const that = this;
				that.dialog_adminlog.show = true;
				that.$post('consoleLog', {
					page: that.dialog_adminlog.page
				}).then(res => {
					setTimeout(function() {
						that.dialog_adminlog.loading = false;
						that.dialog_adminlog.list = res.data.list;
						that.dialog_adminlog.total = res.data.total;
					}, 500);
				}).catch(e => {
					that.dialog_adminlog.show = false;
					that.dialog_adminlog.loading = true;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			postConsole() {
				const that = this;
				that.$post('console').then(res => {
					setTimeout(function() {
						that.loading = false;
						that.tips = res.data.tips;
						that.cost = res.data.cost;
						that.total = res.data.total;
						that.echarts.date = res.data.echarts.date;
						that.echarts.amount = res.data.echarts.amount;
						that.echarts.order = res.data.echarts.order;
						that.echarts.user = res.data.echarts.user;
						that.echarts.comment = res.data.echarts.comment;
						that.adminlog = res.data.adminlog;
						// 加载走势图
						that.onEcharts();
					}, 500);
				}).catch(e => {
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		},
		watch: {
			$route: {
				handler: 'onEcharts'
			}
		}
	}
</script>

<style scoped>
	.tips {
		margin-bottom: 1.25rem;
	}

	.tips div {
		display: flex;
		align-items: center;
		padding: .5rem;
		border-radius: .3125rem;
	}

	.tips div.box {
		margin-top: 1rem;
	}

	.tips div.box:nth-child(1) {
		margin-top: 0;
	}

	.tips div.box .el-icon-warning {
		font-size: 2rem;
		margin-right: .3125rem
	}

	.total .box {
		display: flex;
		height: 9.6rem;
		justify-content: center;
		flex-direction: column;
	}

	.total .box .content {
		position: relative;
		overflow: hidden;
		text-align: right;
		padding: 1rem 0.75rem;
		border-radius: 4px;
		background-color: #f8f8f8;
	}

	.total .box .content.abg {
		background-color: #eef9e8;
	}

	.total .box .content.abg i {
		color: #c8f5b0;
	}

	.total .box .content.bbg {
		background-color: #f4f9ff;
	}

	.total .box .content.bbg i {
		color: #d5e8ff;
	}

	.total .box .content.cbg {
		background-color: #fff7e8;
	}

	.total .box .content.cbg i {
		color: #ffecc9;
	}

	.total .box .content.dbg {
		background-color: #f1e5ff;
	}

	.total .box .content.dbg i {
		color: #d7b6fd;
	}

	.total .box .content.ebg {
		background-color: #ffe5e5;
	}

	.total .box .content.ebg i {
		color: #ffcfcf;
	}

	.total .box .content i {
		position: absolute;
		right: 0;
		bottom: 0;
		color: black;
		font-size: 3rem;
	}

	.total .box .content.zr {
		padding-right: 1.2rem;
		cursor: pointer;
	}

	.total .box .content i.el-icon-arrow-right {
		color: black;
		top: 50%;
		right: 0.3rem;
		font-size: 1rem;
		margin-top: -.5rem;
	}

	.total .box .content .z {
		position: absolute;
		left: 0.75rem;
		font-size: 0.875rem;
	}

	.total .box .content .b {
		font-size: 0.75rem;
	}

	.total .box .content .h {
		position: relative;
		width: 100%;
	}

	.total .box .content .h .l {
		width: 100%;
		color: #666;
		text-align: left;
		font-size: 0.75rem;
	}

	.total .box .content .h .r {
		position: absolute;
		top: -0.1875rem;
		right: 0;
		color: #333;
		text-align: right;
		font-size: 1rem;
		font-weight: bold;
	}

	.total .box .content .num {
		position: relative;
		height: 1.5625rem;
		margin-top: 0.9375rem;
	}

	.total .box .content .num .n {
		position: absolute;
		font-family: WechatSans;
		color: darkred;
		font-size: 1.3rem;
		font-weight: bold;
		line-height: 1.5625rem;
	}

	.total .box .content .num .el-icon-loading {
		position: absolute;
		left: 0;
		font-size: 1.3rem;
	}

	.cost {
		display: flex;
		position: relative;
		height: 9.6rem;
		flex-direction: column;
	}

	.cost .title {
		height: 1.16rem;
		line-height: 1.16rem;
	}

	.cost .title .l,
	.cost .title .r {
		display: inline-block;
		color: #666;
		font-size: 0.875rem;
	}

	.cost .title .r.more {
		text-align: right;
	}

	.cost .con {
		flex: 1;
		margin-top: 1.25rem;
	}

	.cost .con .box {
		display: flex;
		height: 100%;
		justify-content: center;
		flex-direction: column;
	}

	.cost .con .box .item {
		display: flex;
		font-size: 0.875rem;
		margin: 0.5rem 0;
	}

	.cost .con .box .item .l {
		width: 26%;
		color: #99a9bf;
	}

	.cost .con .box .item .r {
		flex: 1;
		font-weight: bold;
	}

	.cost .con .box .item .r .el-tooltip {
		margin-left: 0.2rem;
		cursor: pointer;
	}

	.cost .con .box .item .r .btn {
		margin-left: 1.875rem;
	}

	.box-card-help {
		height: 20.25rem;
	}

	.box-card-help>>>.el-card__body {
		padding: 0.625rem 1.25rem;
	}

	.box-card-help>>>.el-card__header {
		font-weight: bold;
	}

	.box-card-help>>>.el-card__header .more {
		float: right;
		font-size: 0.875rem;
	}

	.box-card-help .item {
		display: flex;
		align-items: center;
		width: 100%;
		font-size: 0.875rem;
		height: 2.5rem;
		border-bottom: 1px #EEEEEE solid;
	}

	.box-card-help .item .text {
		flex: 1;
		padding-right: 1.25rem;
		box-sizing: border-box;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.box-card-help .item .time {
		display: flex;
		font-size: 0.75rem;
		color: #999;
	}

	.box-card-help .item:last-child {
		border-bottom: 0;
	}

	.box-card-help.copys>>>.el-card__body {
		padding: 1.25rem;
	}

	.box-card-help.copys>>>.el-card__body .box .el-form-item {
		width: 100%;
		margin-right: 0;
		margin-bottom: 0;
	}

	.box-card-help.copys>>>.el-card__body .box .el-form-item label {
		width: 30%;
		color: #99a9bf;
		font-size: 0.8125rem;
	}

	.box-card-help.copys>>>.el-card__body .box .el-form-item .el-form-item__content {
		width: 70%;
		font-size: 0.8125rem;
	}

	.copys {
		position: relative;
	}

	.copys .lx_code {
		position: absolute;
		top: 4.375rem;
		right: 0.625rem;
		width: 5.6rem;
		height: 5.6rem;
	}

	.copys .lx_code img {
		width: 100%;
	}

	.amount-qrcode {
		text-align: center;
		margin-bottom: 1.25rem;
	}

	.amount-qrcode img {
		width: 12.5rem;
		height: 12.5rem;
	}

	.amount-tips {
		color: #07C160;
		font-size: 0.875rem;
		text-align: center;
	}
</style>
